module.exports = __webpack_public_path__ + "static/media/reject.572027d2.svg";